import React, {useState, useEffect} from "react";
import {Container, Form, Button, Tabs, Tab, Alert, Row, Col} from "react-bootstrap";
import axios from "./axiosConfig";
import "./AddPrometheus.css";
// @ts-ignore
import YAML from "js-yaml";

const PrometheusConfig: React.FC = () => {
    const [activeTab, setActiveTab] = useState("addSource");
    const [name, setName] = useState("");
    const [url, setURL] = useState("");
    const [accessToken, setAccessToken] = useState("");
    const [secure, setSecure] = useState(false);
    const [configContent, setConfigContent] = useState("");
    const [rulesContent, setRulesContent] = useState("");
    const [selectedRulesPaths, setSelectedRulesPaths] = useState<string[]>([]);
    const [errors, setErrors] = useState({name: "", url: "", accessToken: ""});
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    // Hardcoded rules file paths
    const rulesPaths = [
        "/etc/prometheus/bgp_state_rules.yml",
        "/etc/prometheus/cpu_usage_rules.yml",
        "/etc/prometheus/mem_usage_rules.yml",
        "/etc/prometheus/dr_value_rules.yml",
    ];

    // Fetch Prometheus.yml configuration file content
    const fetchConfig = async () => {
        try {
            const response = await axios.get(`/api/prometheus/config`);
            setConfigContent(response.data); // Set fetched content to state
        } catch (error) {
            setErrorMessage("Failed to fetch Prometheus configuration.");
        }
    };

    // Save Prometheus.yml configuration
    const handleSaveConfig = async () => {
        try {
            YAML.load(configContent); // Validate YAML format
            await axios.post(`/api/prometheus/config`, {content: configContent});
            setSuccessMessage("Prometheus configuration saved successfully!");
            setErrorMessage(null);
        } catch (error) {
            if (error instanceof YAML.YAMLException) {
                // @ts-ignore
                setErrorMessage(`Invalid YAML format: ${error.message}`);
            } else {
                setErrorMessage("Failed to save Prometheus configuration.");
            }
        }
    };

    // Fetch rules file content
const fetchRules = async (paths: string[]) => {
    try {
        const queryParams = paths.map((path) => `rulesPaths=${encodeURIComponent(path)}`).join("&");
        const response = await axios.get(`/api/prometheus/rules?${queryParams}`);
        setRulesContent(response.data); // Set fetched content to state
    } catch (error) {
        setErrorMessage("Failed to fetch Prometheus rules.");
    }
};

    // Save rules content
    const handleSaveRules = async () => {
        try {
            // Validate YAML content only if editing is enabled
            if (selectedRulesPaths.length === 1) {
                YAML.load(rulesContent); // Validate YAML format
            }

            // Construct the payload based on the number of selected paths
            const payload =
                selectedRulesPaths.length === 1
                    ? {rulesPath: selectedRulesPaths[0],content: rulesContent,}
                    : {rulesPaths: selectedRulesPaths,content: null,};

            // Send the payload to the backend
            await axios.post(`/api/prometheus/rules`, payload);

            setSuccessMessage("Prometheus rules saved successfully!");
            setErrorMessage(null);
        } catch (error) {
            if (error instanceof YAML.YAMLException) {
                // @ts-ignore
                setErrorMessage(`Invalid YAML format: ${error.message}`);
            } else {
                setErrorMessage("Failed to save Prometheus rules.");
            }
        }
    };

    // Handle changes to selected rule file paths
    const handleRulesPathsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
        setSelectedRulesPaths(selectedOptions);

        // Simulate loading file content
        const combinedContent = selectedOptions
            .map((path) => `# Content of ${path}`)
            .join("\n---\n");
        setRulesContent(combinedContent);
    };

    // Handle form submission for adding data source
    const handleAddSource = async (event: React.FormEvent) => {
        event.preventDefault();
        const newErrors = {name: "", url: "", accessToken: ""};
        if (!name) newErrors.name = "Name is required";
        if (!url) newErrors.url = "URL is required";
        if (!accessToken) newErrors.accessToken = "AccessToken is required";
        setErrors(newErrors);
        if (!name || !url || !accessToken) return;

        const dataSource = {name, url, accessToken, type: "Prometheus", secure};
        try {
            const response = await axios.post("/api/data-sources", dataSource);
            if (response.status === 200) {
                setSuccessMessage("Prometheus data source added successfully!");
                setErrors({name: "", url: "", accessToken: ""});
                setName("");
                setURL("");
                setAccessToken("");
                setSecure(false);
            } else {
                setErrorMessage("Failed to add Prometheus data source.");
            }
        } catch (error) {
            setErrorMessage("Error adding Prometheus data source.");
        }
    };

     // Automatically fetch Prometheus.yml content when the tab is activated
    useEffect(() => {
        if (activeTab === "prometheusConfig") {
            fetchConfig();
        }
    }, [activeTab]);

    // Automatically fetch rules content when selectedRulesPaths changes
    useEffect(() => {
        if (selectedRulesPaths.length > 0) {
            fetchRules(selectedRulesPaths);
        }
    }, [selectedRulesPaths]);

    return (
        <Container>
            <h1 className="my-4">Prometheus Management</h1>
            {successMessage && (
                <Alert variant="success" onClose={() => setSuccessMessage(null)} dismissible>
                    {successMessage}
                </Alert>
            )}
            {errorMessage && (
                <Alert variant="danger" onClose={() => setErrorMessage(null)} dismissible>
                    {errorMessage}
                </Alert>
            )}
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k || "addSource")} className="mb-3 my-dark-tabs">
                {/*<Tab eventKey="addSource" title="Add Data Source">*/}
                {/*    <Form onSubmit={handleAddSource}>*/}
                {/*        <Form.Group controlId="dataSourceSettings" className="mb-3">*/}
                {/*            <Form.Label>Authentication</Form.Label>*/}
                {/*            <Form.Control*/}
                {/*                type="text"*/}
                {/*                placeholder="URL"*/}
                {/*                value={url}*/}
                {/*                onChange={(e) => setURL(e.target.value)}*/}
                {/*                className={`mb-2 ${errors.url ? "is-invalid" : ""}`}*/}
                {/*            />*/}
                {/*            {errors.url && <div className="invalid-feedback">{errors.url}</div>}*/}

                {/*            <Form.Control*/}
                {/*                type="text"*/}
                {/*                placeholder="Name"*/}
                {/*                value={name}*/}
                {/*                onChange={(e) => setName(e.target.value)}*/}
                {/*                className={`mb-2 ${errors.name ? "is-invalid" : ""}`}*/}
                {/*            />*/}
                {/*            {errors.name && <div className="invalid-feedback">{errors.name}</div>}*/}

                {/*            <Form.Control*/}
                {/*                type="password"*/}
                {/*                placeholder="AccessToken"*/}
                {/*                value={accessToken}*/}
                {/*                onChange={(e) => setAccessToken(e.target.value)}*/}
                {/*                className={`mb-2 ${errors.accessToken ? "is-invalid" : ""}`}*/}
                {/*            />*/}
                {/*            {errors.accessToken && <div className="invalid-feedback">{errors.accessToken}</div>}*/}

                {/*            <Form.Check*/}
                {/*                type="switch"*/}
                {/*                label="Secure"*/}
                {/*                checked={secure}*/}
                {/*                onChange={(e) => setSecure(e.target.checked)}*/}
                {/*            />*/}
                {/*        </Form.Group>*/}
                {/*        <Row className="mb-3">*/}
                {/*            <Col>*/}
                {/*                <Button variant="primary" type="submit" className="w-100">*/}
                {/*                    Save & Test*/}
                {/*                </Button>*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*    </Form>*/}
                {/*</Tab>*/}
                <Tab eventKey="prometheusConfig" title="Prometheus.yml">
                    <Form.Group controlId="prometheusConfig">
                        <Form.Label>Edit Prometheus.yml</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={20}
                            value={configContent}
                            onChange={(e) => setConfigContent(e.target.value)}
                        />
                    </Form.Group>
                    <Button variant="primary" onClick={handleSaveConfig}>
                        Save Configuration
                    </Button>
                </Tab>
                {/*<Tab eventKey="rulesConfig" title="Rules">*/}
                {/*    <Form.Group controlId="rulesFileSelection" className="mb-3">*/}
                {/*        <Form.Label>Select Rules Files</Form.Label>*/}
                {/*        <Form.Select*/}
                {/*            multiple*/}
                {/*            value={selectedRulesPaths}*/}
                {/*            onChange={handleRulesPathsChange}*/}
                {/*        >*/}
                {/*            {rulesPaths.map((path, index) => (*/}
                {/*                <option key={index} value={path}>*/}
                {/*                    {path}*/}
                {/*                </option>*/}
                {/*            ))}*/}
                {/*        </Form.Select>*/}
                {/*        {selectedRulesPaths.length > 1 && (*/}
                {/*            <small className="text-muted">*/}
                {/*                Multiple files selected. Editing and saving are disabled.*/}
                {/*            </small>*/}
                {/*        )}*/}
                {/*    </Form.Group>*/}
                {/*    <Form.Group controlId="prometheusRules">*/}
                {/*        <Form.Label>Edit Alerting/Recording Rules</Form.Label>*/}
                {/*        <Form.Control*/}
                {/*            as="textarea"*/}
                {/*            rows={20}*/}
                {/*            value={rulesContent}*/}
                {/*            onChange={(e) => setRulesContent(e.target.value)}*/}
                {/*            readOnly={selectedRulesPaths.length > 1} // Disable editing if multiple files are selected*/}
                {/*        />*/}
                {/*    </Form.Group>*/}
                {/*    <Button*/}
                {/*        variant="primary"*/}
                {/*        onClick={handleSaveRules}*/}
                {/*        disabled={selectedRulesPaths.length === 0 || selectedRulesPaths.length > 1} // Disable saving if multiple files are selected*/}
                {/*    >*/}
                {/*        Save Rules*/}
                {/*    </Button>*/}
                {/*</Tab>*/}
            </Tabs>
        </Container>
    );
};

export default PrometheusConfig;
